import React, { useEffect } from 'react';
import { auth, db, storage } from '../lib/firebase';
import { initializePosts } from '../lib/initializeFirebase';

interface FirebaseContextValue {
  auth: typeof auth;
  db: typeof db;
  storage: typeof storage;
}

export const FirebaseContext = React.createContext<FirebaseContextValue>({
  auth,
  db,
  storage
});

export function FirebaseProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Initialize Firebase collections
    initializePosts();
  }, []);

  return (
    <FirebaseContext.Provider value={{ auth, db, storage }}>
      {children}
    </FirebaseContext.Provider>
  );
}